var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24.2145996px",
    height: "25.0627731px",
    viewBox: "0 0 24.2145996 25.0627731",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor-Plans---Desktop-1200",
    transform: "translate(-1053.3079, -1693.5)",
    stroke: "#A95052",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1018.6, 1553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(35.7079, 141.5)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 11.1921387,
    y1: -4.25795762e-17,
    x2: 11.1921387,
    y2: 21,
    id: "Line"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    points: "0 11.5412598 11.1072998 22.6485596 22.2145996 11.5412598"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/DownloadIcon.9386d0008ac134900c89ec88e92bbfff.svg";
export { ForwardRef as ReactComponent };